import { Content, DefaultPage } from "@shared/layout/DefaultPage";
import { useIonRouter } from "@ionic/react";
import { observer } from "mobx-react";
import { ROUTES } from "@shared/constants/routes";
import { useUserService } from "@entities/User";
import { useLocation } from "react-router";
import { ProfileHome } from "@pages/Profile/ui/profile-home";
import { useTranslation } from "react-i18next";
import { ProfileDetailsPage } from "@pages/Profile/ui/profile-details-page";
import {
  getProfileInfoSectionPath,
  isProfileInfoSectionType,
  PROFILE_INFO_SECTION_QUERY_PARAM,
} from "@shared/constants/profile";

export const Profile = observer(() => {
  const nav = useIonRouter();
  const userService = useUserService();
  const { t } = useTranslation("common");
  const location = useLocation();
  const userData = userService?.data;

  if (!userData) {
    return <div>{t("errors.userDataNotFound")}</div>;
  }

  const search = location.search;
  const params = new URLSearchParams(search);
  const requestedType = params.get(PROFILE_INFO_SECTION_QUERY_PARAM);

  if (isProfileInfoSectionType(requestedType)) {
    return (
      <ProfileDetailsPage
        activeTab={requestedType}
        onTabChange={(type) =>
          nav.push(getProfileInfoSectionPath(type), "none", "replace")
        }
      />
    );
  }

  return (
    <DefaultPage noPadding>
      <Content className="[--background:#FEFEFC]" scrollY={false}>
        <ProfileHome
          avatarUrl={userService?.avatarUrl}
          userData={userData}
          onEditClick={() => nav.push(ROUTES.overall.profileEdit)}
          onInfoClick={() => nav.push(ROUTES.overall.aboutUs)}
          onInfoPanelClick={(type) => {
            if (isProfileInfoSectionType(type)) {
              nav.push(getProfileInfoSectionPath(type));
            }
          }}
        />
      </Content>
    </DefaultPage>
  );
});
